<div #pagetop class="card shadow mb-4">
    <div class="card-header py-3">
        <div class="row">
            <h5 *ngIf="!isEditForm" class="col-9 m-0 font-weight-bold text-primary">
                {{ 'add-single-news' | translate }}
            </h5>
            <h5 *ngIf="isEditForm" class="col-9 m-0 font-weight-bold text-primary">
                {{ 'edit-single-news' | translate }}
            </h5>
        </div>
    </div>
    <div *ngIf="singleNews" class="card-body">
        <form #form4="ngForm" autocomplete="off" (keydown.enter)="onEnterPress($event,form4.invalid)">

            <div class="form-group">
                <div class="input-group">
                    *<div class="font-weight-bold">{{ 'news-content' | translate }}</div>
                </div>
                <div class="input-group">
                    <textarea name="name" #name="ngModel" [(ngModel)]="singleNews.name" class="form-control"
                        required></textarea>
                </div>
                <div *ngIf="name.invalid && (name.dirty || name.touched)" class="text-danger mx-2 my-1">
                    <div *ngIf="name.errors.required">{{ 'news-content-required' | translate }}</div>
                </div>
            </div>

            <div class="form-group row">
                <button class="btn btn-danger m-1" (click)="router.navigate(['workSchedule'])">{{ 'back' | translate }}</button>
                <button class="btn btn-primary m-1" type="submit" [disabled]="formSubmitted || form4.invalid"
                    (click)="onSubmit()">
                    <span *ngIf="formSubmitted" class="spinner-border spinner-border-sm my-1" role="status"
                        aria-hidden="true"></span>{{ 'save-news-content' | translate }}
                </button>
            </div>
        </form>
    </div>
</div>